"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tone = require("tone");
var tone_1 = require("tone");
var types_1 = require("./types");
var life_cycle_1 = require("./life-cycle");
var timestretcher_1 = require("./timestretcher");
var TonejsScheduledObject = /** @class */ (function (_super) {
    __extends(TonejsScheduledObject, _super);
    function TonejsScheduledObject(startTime, timings) {
        var _this = _super.call(this) || this;
        _this.startTime = startTime;
        _this.timings = timings;
        _this.scheduledEvents = new Map();
        if (_this.startTime.onset == null)
            _this.startTime.onset = 0;
        return _this;
    }
    TonejsScheduledObject.prototype.getScheduleTime = function () {
        return this.startTime.ref + this.startTime.onset;
    };
    TonejsScheduledObject.prototype.updatePlayTime = function () {
        this.playTime = this.startTime.ref + this.startTime.onset + this.timings.connectToGraph.countIn;
    };
    /** schedules an event with the given task, adds it to the scheduled map,
      and returns a promise that gets resolved when the event is triggered, to
      enable scheduling dependent events. errors are simply caught and printed */
    TonejsScheduledObject.prototype.scheduleEvent = function (name, time, task) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var event = new tone_1.Event(function (time) { return __awaiter(_this, void 0, void 0, function () {
                var err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!task) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, task(time)];
                        case 2:
                            _a.sent();
                            //console.log(name, time);
                            this.emit(name, time);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            console.warn(err_1); //, this.fileUri);
                            return [3 /*break*/, 4];
                        case 4:
                            resolve();
                            _a.label = 5;
                        case 5: return [2 /*return*/];
                    }
                });
            }); });
            var oldEvent = _this.scheduledEvents.get(name);
            _this.scheduledEvents.set(name, event);
            event.start(time);
            //dispose old event and replace
            if (oldEvent) {
                oldEvent.cancel();
                oldEvent.dispose();
            }
        });
    };
    TonejsScheduledObject.prototype.removeAllEvents = function () {
        if (this.scheduledEvents.size > 0) {
            this.scheduledEvents.forEach(function (event) { return event.cancel(); });
            this.scheduledEvents.forEach(function (event) { return event.dispose(); });
            this.scheduledEvents = new Map();
        }
    };
    return TonejsScheduledObject;
}(Tone.Emitter));
exports.TonejsScheduledObject = TonejsScheduledObject;
var PLAYER = "player";
var PANNER = "panner";
var DELAY = "delay";
var REVERB = "reverb";
var TonejsAudioObject = /** @class */ (function (_super) {
    __extends(TonejsAudioObject, _super);
    function TonejsAudioObject(fileUri, audioBank, timings, fadeLength, reverb, delay, startTime) {
        var _this = _super.call(this, startTime, timings) || this;
        _this.fileUri = fileUri;
        _this.audioBank = audioBank;
        _this.fadeLength = fadeLength;
        _this.reverb = reverb;
        _this.delay = delay;
        _this.parameterDispatchers = new Map();
        _this.audioGraph = new Map();
        _this.startTimeDependentKeys = ['playing', 'scheduled', 'loaded'];
        _this.durationDependentKeys = ['stopped', 'disposed', 'freed'];
        _this.isScheduled = false;
        _this.isPlaying = false;
        _this.isDonePlaying = false;
        _this.offset = 0;
        _this.durationRatio = 1;
        _this.timeStretchRatio = 1;
        _this.initParamDispatchers();
        _this.updateStartEvents();
        return _this;
    }
    TonejsAudioObject.prototype.initParamDispatchers = function () {
        var _this = this;
        this.parameterDispatchers.set(types_1.Parameter.Amplitude, new life_cycle_1.StoredValueHandler({
            currentValue: 1.0,
            handler: function (n) { return _this.setGain(PLAYER, n); }
        }));
        this.parameterDispatchers.set(types_1.Parameter.Panning, new life_cycle_1.StoredValueHandler({
            currentValue: [0.0, 0.0, 0.0],
            handler: function (n) {
                return _this.audioGraph.get(PANNER).setPosition(n[0], n[1], n[2]);
            }
        }));
        this.parameterDispatchers.set(types_1.Parameter.Reverb, new life_cycle_1.StoredValueHandler({
            currentValue: 0.0,
            handler: function (n) { return _this.setGain(REVERB, n * 2); }
        }));
        this.parameterDispatchers.set(types_1.Parameter.Delay, new life_cycle_1.StoredValueHandler({
            currentValue: 0.0,
            handler: function (n) { return _this.setGain(DELAY, n); }
        }));
        this.parameterDispatchers.set(types_1.Parameter.PlaybackRate, new life_cycle_1.StoredValueHandler({
            currentValue: 1.0,
            handler: function (n) {
                return _this.audioGraph.get(PLAYER).playbackRate = n;
            }
        }));
        /*TODO for now time stretching made with playback rate held stable during playback
        this.parameterDispatchers.set(
          Parameter.TimeStretchRatio,
          new StoredValueHandler({
            currentValue: 1.0,
            handler: (n: number) => {
              if (!this.isScheduled) {
                (<Player>this.audioGraph.get(PLAYER)).playbackRate = n
              }
            }
          })
        );*/
    };
    TonejsAudioObject.prototype.setGain = function (nodeName, value) {
        var db = Tone.gainToDb(value);
        var volume = this.audioGraph.get(nodeName).volume;
        if (volume) {
            this.audioGraph.get(nodeName).volume.value = db;
        }
    };
    TonejsAudioObject.prototype.set = function (param, value) {
        var dispatch = this.parameterDispatchers.get(param);
        if (dispatch) {
            dispatch.stored.currentValue = value;
            if (this.isScheduled) {
                try {
                    dispatch.update();
                }
                catch (err) {
                    console.warn(err);
                }
            }
        }
        else if (param === types_1.Parameter.StartTime) {
            if (!this.isScheduled && this.startTime.onset != value) {
                this.startTime.onset = value;
                this.updateStartEvents();
                this.updateEndEvents();
            }
        }
        else if (param === types_1.Parameter.Duration && this.duration != value && !this.isScheduled) {
            this.duration = value;
            this.updateEndEvents();
        }
        else if (param === types_1.Parameter.DurationRatio && this.durationRatio != value && !this.isScheduled) {
            this.durationRatio = value;
            this.updateEndEvents();
        }
        else if (param === types_1.Parameter.TimeStretchRatio && this.timeStretchRatio != value && !this.buffer) {
            this.timeStretchRatio = value;
            this.updateEndEvents();
        }
        else if (param === types_1.Parameter.Offset && this.offset != value && !this.buffer) {
            this.offset = value;
        }
    };
    TonejsAudioObject.prototype.ramp = function (param, value, duration, time) {
        if (param === types_1.Parameter.Amplitude) {
            this.audioGraph.get(PLAYER).volume.linearRampTo(value, duration, time);
        }
    };
    //stopped from outside
    TonejsAudioObject.prototype.stop = function (time, mode) {
        this.stopPlayer();
        this.removeAllEvents();
        this.scheduleStopAndCleanup(Tone.Transport.seconds);
    };
    TonejsAudioObject.prototype.getDuration = function () {
        if (this.duration) {
            return this.duration * this.durationRatio;
        } /* else if (this.buffer) {
          return (this.buffer.duration - this.offset)*this.durationRatio;
        }*/
        return 0;
    };
    TonejsAudioObject.prototype.updateStartEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                //console.log("UPD", Tone.Transport.seconds, "L", this.timings.loadBuffer.countIn, "S", this.timings.connectToGraph.countIn)
                this.updatePlayTime();
                this.loadTime = this.toFutureTime(this.playTime - this.timings.loadBuffer.countIn);
                this.loading = this.scheduleEvent('loaded', this.loadTime, this.initBuffer.bind(this));
                if (this.scheduledEvents.size > 0) { //simple way to check not cancelled
                    this.schedTime = this.toFutureTime(this.playTime - this.timings.connectToGraph.countIn);
                    //console.log(this.loadTime-Tone.Transport.seconds, this.schedTime-this.loadTime, this.playTime-this.schedTime)
                    this.scheduling = this.scheduleEvent('scheduled', this.schedTime, this.initAndSchedulePlayer.bind(this));
                    this.scheduleEvent('playing', this.playTime, this.enterPlayState.bind(this));
                }
                return [2 /*return*/];
            });
        });
    };
    // Tone.js won't schedule an event if it isn't in the future,
    // so this function checks against "now" and adds a small offset
    TonejsAudioObject.prototype.toFutureTime = function (ideal, delta) {
        if (delta === void 0) { delta = 0.001; }
        var now = Tone.Transport.seconds;
        return ideal <= now ? now + delta : ideal;
    };
    TonejsAudioObject.prototype.updateEndEvents = function () {
        if (this.buffer && this.isScheduled && !this.isDonePlaying) {
            var duration = this.getDuration();
            //console.log(this.startTime.ref, this.duration, this.durationRatio, duration, (<Player>this.audioGraph.get(PLAYER)).playbackRate)
            if (duration) {
                this.scheduleStopAndCleanup(this.playTime + duration);
            }
        }
    };
    TonejsAudioObject.prototype.scheduleStopAndCleanup = function (stopTime) {
        if (stopTime > Tone.Transport.seconds || !this.scheduledEvents.has('stopped')) {
            var fadedTime = stopTime + this.fadeLength;
            var disposeTime = fadedTime + this.timings.connectToGraph.countOut;
            var freeTime = fadedTime + this.timings.loadBuffer.countOut;
            this.scheduleEvent('stopped', stopTime, this.stopPlayer.bind(this));
            this.scheduleEvent('disposed', disposeTime, this.resetGraph.bind(this));
            this.scheduleEvent('freed', freeTime, this.freeBuffer.bind(this));
        }
    };
    // LIFE CYCLE EVENT FUNCTIONS ////////////////////
    // most of these throw errors when appropriate to prevent events from emitting
    TonejsAudioObject.prototype.initBuffer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var t, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.fileUri) return [3 /*break*/, 2];
                        t = Tone.Transport.seconds;
                        _a = this;
                        return [4 /*yield*/, this.audioBank.getToneBuffer(this.fileUri)];
                    case 1:
                        _a.buffer = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TonejsAudioObject.prototype.freeBuffer = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.buffer) {
                    throw "no buffer to free";
                }
                this.buffer.dispose();
                this.buffer = null;
                this.audioBank.freeBuffer(this.fileUri);
                //completely done, so remove all events
                this.removeAllEvents();
                return [2 /*return*/];
            });
        });
    };
    TonejsAudioObject.prototype.initAndSchedulePlayer = function () {
        return __awaiter(this, void 0, void 0, function () {
            var panner, processedBuffer, player, offsetCorr;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.loading) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loading];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!this.buffer) {
                            console.warn("buffer not loaded in time");
                            //increase load ahead time
                            this.increaseCountIn(this.timings.loadBuffer, 0.5);
                        }
                        else if (this.playTime < Tone.Transport.seconds) {
                            console.warn("scheduled too late", this.buffer);
                            //increase schedule ahead time
                            this.increaseCountIn(this.timings.loadBuffer, 0.2);
                            this.increaseCountIn(this.timings.connectToGraph, 0.2);
                            //try decreasing load ahead time
                            this.decreaseCountIn(this.timings.loadBuffer, 0.01);
                        }
                        else {
                            //try decreasing schedule and loading ahead time
                            this.decreaseCountIn(this.timings.connectToGraph, 0.01);
                            this.decreaseCountIn(this.timings.loadBuffer, 0.01);
                            this.audioGraph.set(REVERB, new Tone.Volume(0).connect(this.reverb));
                            this.audioGraph.set(DELAY, new Tone.Volume(0).connect(this.delay));
                            panner = Tone.context.createPanner();
                            panner.connect(Tone.Master);
                            this.audioGraph.set(PANNER, panner);
                            panner.connect(this.audioGraph.get(REVERB));
                            panner.connect(this.audioGraph.get(DELAY));
                            processedBuffer = new timestretcher_1.TimeStretcher(Tone.context, this.fadeLength)
                                .getStretchedTrimmedBuffer(this.buffer.get(), this.timeStretchRatio, this.offset, this.getDuration());
                            player = new Tone.Player(new Tone.Buffer(processedBuffer));
                            this.audioGraph.set(PLAYER, player);
                            offsetCorr = Math.min(this.offset, (this.fadeLength / 2));
                            player.sync().start(this.playTime - offsetCorr); //, this.offset-offsetCorr);//no duration given, makes it dynamic
                            player.connect(panner);
                            player.fadeIn = this.fadeLength;
                            player.fadeOut = this.fadeLength;
                            this.parameterDispatchers.forEach(function (dispatcher, paramType) {
                                if (paramType != types_1.Parameter.StartTime) { // will cause infinite loop
                                    dispatcher.update();
                                }
                            });
                            this.isScheduled = true;
                            //end events only updated once buffer is there and scheduled
                            this.updateEndEvents();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    TonejsAudioObject.prototype.increaseCountIn = function (window, increment) {
        //adjust min so never goes below that again
        if (window.countIn == window.minCountIn) {
            window.minCountIn += increment;
        }
        window.countIn += increment;
    };
    TonejsAudioObject.prototype.decreaseCountIn = function (window, decrement) {
        window.countIn = Math.max(window.minCountIn, window.countIn - decrement);
    };
    TonejsAudioObject.prototype.stopPlayer = function () {
        this.exitPlayState();
        var player = this.audioGraph.get(PLAYER);
        if (player) {
            if (player.volume) {
                player.volume.rampTo(Tone.gainToDb(0), this.fadeLength);
            }
            setTimeout(function () {
                //these calls often produce errors due to inconsistencies in tone
                try {
                    player.unsync();
                }
                catch (e) { }
                ;
                try {
                    player.stop();
                }
                catch (e) { }
                ;
            }, this.fadeLength * 1000);
        }
    };
    TonejsAudioObject.prototype.resetGraph = function () {
        this.audioGraph.forEach(function (node) { return node.dispose ? node.dispose() : node.disconnect(); });
        this.audioGraph.clear();
    };
    TonejsAudioObject.prototype.enterPlayState = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.isPlaying = true;
                return [2 /*return*/];
            });
        });
    };
    TonejsAudioObject.prototype.exitPlayState = function () {
        this.isPlaying = false;
        this.isDonePlaying = true;
    };
    return TonejsAudioObject;
}(TonejsScheduledObject));
exports.TonejsAudioObject = TonejsAudioObject;
var TonejsEventObject = /** @class */ (function (_super) {
    __extends(TonejsEventObject, _super);
    function TonejsEventObject(triggerFunction, startTime, timings) {
        var _this = _super.call(this, startTime, timings) || this;
        _this.triggerFunction = triggerFunction;
        _this.updateEvent();
        return _this;
    }
    TonejsEventObject.prototype.set = function (param, value) {
        if (param === types_1.Parameter.StartTime) {
            if (!this.isScheduled && this.startTime.onset != value) {
                this.startTime.onset = value;
                this.updateEvent();
            }
        }
    };
    TonejsEventObject.prototype.stop = function (time, mode) {
        this.removeAllEvents();
    };
    TonejsEventObject.prototype.getDuration = function () {
        return 0;
    };
    TonejsEventObject.prototype.updateEvent = function () {
        this.updatePlayTime();
        this.scheduleEvent('scheduled', this.playTime, this.triggerFunction);
    };
    return TonejsEventObject;
}(TonejsScheduledObject));
exports.TonejsEventObject = TonejsEventObject;



//////////////////
// WEBPACK FOOTER
// ./~/schedulo/lib/tone-object.js
// module id = 2053
// module chunks = 3